// skipcq: JS-W1028
import posthog from 'posthog-js';

let posthogInitialized = false;

/**
 * Initialize PostHog when `VITE_POSTHOG_KEY` is set (no-op in tests or missing env).
 */
export function initPostHog() {
  const apiKey = import.meta.env.VITE_POSTHOG_KEY;
  if (typeof apiKey !== 'string' || apiKey.trim().length === 0) {
    return;
  }
  if (posthogInitialized) {
    return;
  }
  const apiHost =
    typeof import.meta.env.VITE_POSTHOG_HOST === 'string' &&
    import.meta.env.VITE_POSTHOG_HOST.trim().length > 0
      ? import.meta.env.VITE_POSTHOG_HOST.trim()
      : 'https://us.i.posthog.com';
  posthog.init(apiKey.trim(), {
    api_host: apiHost,
    capture_pageview: false,
    persistence: 'localStorage',
  });
  posthogInitialized = true;
}

/**
 * @param {string} eventName
 * @param {Record<string, unknown>} [properties]
 */
export function capturePostHogEvent(eventName, properties) {
  try {
    const apiKey = import.meta.env.VITE_POSTHOG_KEY;
    if (typeof apiKey !== 'string' || apiKey.trim().length === 0) {
      return;
    }
    initPostHog();
    if (typeof properties === 'object' && properties !== null) {
      posthog.capture(eventName, properties);
      return;
    }
    posthog.capture(eventName);
  } catch (captureError) {
    if (import.meta.env.DEV) {
      console.warn('PostHog capture failed:', captureError);
    }
  }
}
